import { Box, Center } from "@chakra-ui/react"
import { motion } from "framer-motion"
import PropTypes from "prop-types"
import { useFlashcard } from "./FlashcardProvider"

const cardVariants = {
  faceUp: {
    rotateY: 0,
    zIndex: 1,
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 220,
      damping: 40
    }
  },
  faceDown: {
    rotateY: -180,
    zIndex: 0,
    opacity: 0,
    // 0.9 seems to cause a bit of jank
    // scale: 0.9,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 220,
      damping: 40
    }
  }
}

export const CardFace = ({
  children,
  variants,
  initial,
  animate,
  ...props
}) => {
  return (
    <Center
      asChild
      pos="absolute"
      w="full"
      h="full"
      bg="background"
      color="text"
      p={6}
      left={0}
      top={0}
      right={0}
      bottom={0}
      shadow={"0 0 10px 1px rgba(150,150,150,0.3)"}
      overflow={"hidden"}
      textAlign={"center"}
      css={{
        perspective: 1000,
        backfaceVisibility: "hidden"
      }}
      {...props}
    >
      <motion.div variants={variants} initial={initial} animate={animate}>
        {children}
      </motion.div>
    </Center>
  )
}

const CardFlipper = ({ renderFront, renderBack, size = "100%", ...props }) => {
  const { isFlipped, setIsFlipped } = useFlashcard()

  const handleFlip = () => {
    setIsFlipped(!isFlipped)
  }

  return (
    <Box
      asChild
      onClick={handleFlip}
      h={size}
      pos="relative"
      cursor="pointer"
      {...props}
    >
      <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }}>
        <>
          <CardFace
            variants={cardVariants}
            initial={isFlipped ? "faceDown" : "faceUp"}
            animate={isFlipped ? "faceDown" : "faceUp"}
          >
            {renderFront({ onFlip: handleFlip })}
          </CardFace>
          <CardFace
            variants={cardVariants}
            initial={isFlipped ? "faceUp" : "faceDown"}
            animate={isFlipped ? "faceUp" : "faceDown"}
          >
            {renderBack({ onFlip: handleFlip })}
          </CardFace>
        </>
      </motion.div>
    </Box>
  )
}

CardFlipper.propTypes = {
  renderFront: PropTypes.func.isRequired,
  renderBack: PropTypes.func.isRequired,
  size: PropTypes.number
}

export default CardFlipper
